"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const dataUrlHeader = "data:image/png;base64,";
exports.default = {
    idle: dataUrlHeader +
        "iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAGElEQVQYV2P8P9P4PwMSYNycrUJAAF0LAJQ2ChvZR8L6AAAAAElFTkSuQmCC",
    running: dataUrlHeader +
        "iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAP1BMVEVmpC2O5D9opy57xTaD0jqI2z2M4T5mpS18xjeAzjlopi5npS5srTCC0TptrjCG1zyI2jxxtjJzuTON4z96xDYzhdfgAAAALElEQVR4XgWAhRHAIBAE914hbv3XmgHPAwvRrGyXkn3hLoWh83vlDVOqhx4/FI4A+5tDxEUAAAAASUVORK5CYII=",
    stopped: dataUrlHeader +
        "iVBORw0KGgoAAAANSUhEUgAAAAgAAAAIBAMAAAA2IaO4AAAALVBMVEWLNTuLNjyQNz23Rk69SFG9SVHASlLCS1PDS1PGTFTGTFXITVX4X2r8YWz/Ym2E1k9sAAAAMklEQVR4XmPguPe2kSF4720ThuPWm2sY3hSbn2N4u9n6HsNt8+K9DItrjlsyqJ17kwQAcEISZVP4sT8AAAAASUVORK5CYII=",
    undef: dataUrlHeader +
        "iVBORw0KGgoAAAANSUhEUgAAAAgAAAAIAQMAAAD+wSzIAAAABlBMVEWIiIjm5uYS3fXIAAAADklEQVR4XmPgh8IPEAgAEeAD/bSogK0AAAAASUVORK5CYII=",
};
//# sourceMappingURL=index.js.map